// Créneaux de rappel proposés aux visiteurs.
//
// Horaires d'ouverture réels, ceux affichés dans le pied de page et sur la
// page contact : du lundi au jeudi 10h-17h, le vendredi 10h-13h, fermé le
// week-end. Source unique : ne pas réécrire ces horaires ailleurs, les
// modifier ici les propage au formulaire de rappel et à sa validation.

export const HORAIRES = {
  // 1 = lundi … 5 = vendredi (getDay() : 0 = dimanche)
  1: [
    { id: "10-12", libelle: "10h - 12h", debut: 10, fin: 12 },
    { id: "12-14", libelle: "12h - 14h", debut: 12, fin: 14 },
    { id: "14-17", libelle: "14h - 17h", debut: 14, fin: 17 },
  ],
  5: [
    { id: "10-12", libelle: "10h - 12h", debut: 10, fin: 12 },
    { id: "12-13", libelle: "12h - 13h", debut: 12, fin: 13 },
  ],
};
HORAIRES[2] = HORAIRES[1];
HORAIRES[3] = HORAIRES[1];
HORAIRES[4] = HORAIRES[1];

const JOURS = [
  "dimanche", "lundi", "mardi", "mercredi",
  "jeudi", "vendredi", "samedi",
];
const MOIS = [
  "janvier", "février", "mars", "avril", "mai", "juin",
  "juillet", "août", "septembre", "octobre", "novembre", "décembre",
];

/** « 2026-08-13 » — clé stable, indépendante du fuseau d'affichage. */
export const cleJour = (date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(
    date.getDate()
  ).padStart(2, "0")}`;

/** « jeudi 13 août » */
export const libelleLong = (date) =>
  `${JOURS[date.getDay()]} ${date.getDate()} ${MOIS[date.getMonth()]}`;

/**
 * Jours ouvrés à venir qui ont encore au moins un créneau disponible.
 *
 * Un créneau du jour même n'est proposé que s'il reste au moins une heure
 * avant sa fin : promettre un rappel « 14h-17h » à 16h55 ne tient pas.
 */
export const joursDisponibles = (maintenant = new Date(), nbJours = 5) => {
  const resultat = [];
  const curseur = new Date(maintenant);
  curseur.setHours(0, 0, 0, 0);

  for (let i = 0; resultat.length < nbJours && i < 21; i += 1) {
    const jour = new Date(curseur);
    jour.setDate(curseur.getDate() + i);

    const creneauxDuJour = HORAIRES[jour.getDay()];
    if (!creneauxDuJour) continue; // week-end

    const estAujourdhui = cleJour(jour) === cleJour(maintenant);
    const creneaux = creneauxDuJour.filter((c) => {
      if (!estAujourdhui) return true;
      const heureActuelle = maintenant.getHours() + maintenant.getMinutes() / 60;
      return c.fin - heureActuelle >= 1;
    });
    if (!creneaux.length) continue;

    let libelle = libelleLong(jour);
    if (estAujourdhui) libelle = "aujourd'hui";
    else if (i === 1 || (resultat.length === 0 && i <= 3 && estDemain(maintenant, jour)))
      libelle = "demain";

    resultat.push({
      cle: cleJour(jour),
      libelle,
      libelleLong: libelleLong(jour),
      creneaux,
    });
  }
  return resultat;
};

const estDemain = (maintenant, jour) => {
  const demain = new Date(maintenant);
  demain.setDate(demain.getDate() + 1);
  return cleJour(demain) === cleJour(jour);
};

/**
 * Vérifie qu'un couple (jour, créneau) correspond bien à une plage ouverte.
 * Utilisé côté client avant envoi ; le serveur refait la même vérification.
 */
export const creneauValide = (cle, idCreneau, maintenant = new Date()) =>
  joursDisponibles(maintenant, 10).some(
    (j) => j.cle === cle && j.creneaux.some((c) => c.id === idCreneau)
  );
